import { mapKeysToCamelCase } from "~/utils/mapKeys";
import { ParticipantLevel, MediaProperties } from "~/modules/cbm";





export type ConversationMediaProperties = {
    conversationSid: string;
    friendlyName: string | null;
    dateUpdated: string;
    roleSid: string;
    chatbotConfiguration: {
        friendlyName: string | null;
        chatbotProvider: string | null;
        configuration: {
            dialogflowcxModuleSid: string | null;
            dialogflowcxAddonSid: string | null;
        };
    } | null;
    dateCreated: string;
    chatServiceSid: string;
    url: string;
    sid: string;
    lastReadMessageIndex: number | null;
    identity: string | null;
    lastReadTimestamp: string | null;
    messagingBinding: {
        address: string;
        level: ParticipantLevel | null;
        proxyAddress: string | null;
        name: string | null;
        type: string;
        projectedAddress: string | null;
    } | null;
    accountSid: string;
    attributes: string;
} & MediaProperties;

export function toConversationMediaProperties(mediaProperties: MediaProperties): ConversationMediaProperties {
    return mapKeysToCamelCase(mediaProperties) as ConversationMediaProperties;
}
